import { BodyText, Card, Flex, Heading } from '@utilitywarehouse/hearth-react';
import NakedPiggies from '@utilitywarehouse/hearth-svg-assets/lib/scene-mobile-light.svg';

import './styles.scss';

const OfferBanner = () => {
  return (
    <Card
      variant="subtle"
      colorScheme="mobile"
      className="mobile__banner"
      spacing="lg"
    >
      <img
        className="mobile__banner-piggies"
        src={NakedPiggies}
        alt="Phone celebration piggies"
      />
      <Flex direction="column" spacing="sm" className="mobile__banner-content">
        <Heading as="h3" size="sm">
          FREE additional Go Unlimited SIMs
        </Heading>
        <BodyText>
          Connect the whole family for less - get your first Go Unlimited SIM
          for £13, then pay £0.00 for up to three more for 3 months
        </BodyText>
      </Flex>
    </Card>
  );
};

export { OfferBanner };
